<template>
  <div class="chat">
    <div class="chat-panel">
      <ul
        class="chat-messages"
        :class="{ 'nice-scroll': !is_mobile }"
        v-chat-scroll="{ always: false }"
      >
        <li
          v-for="(item, index) in asta_messages"
          :key="index"
          v-bind:class="{ 'my-chat': item.id == user_uid }"
        >
          <div v-if="squadra(item.id)">
            <span
              class="chat-user"
              v-bind:style="{ color: userColor(item.id) }"
              >{{ squadra(item.id).name }}</span
            >
            <div
              class="chat-msg"
              v-html="$options.filters.emoji(item.text, 'unicodeToImage')"
            ></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import toast from "../js/toast";
import db from "../js/db";
import Constants from "../js/constants";

export default {
  name: "asta-chat-messages",
  mixins: [toast],
  mounted() {
    console.log("--> AstaChat ready.");
    // db.on("newMessage", this.onNewMessage);
    /*
      db.on('fetchedSquadre', this.setupEmojioneArea);
      this.setupEmojioneArea();
        */
  },
  methods: {
    // onNewMessage(message) {
    //   //this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
    //   if (message.id != this.user_uid) {
    //     this.newMessageToast(
    //       this.squadra(message.id).name,
    //       this.$options.filters.emoji(message.text, "unicodeToImage")
    //     );
    //   }
    // },
    squadra(id) {
      return this.asta_squadre[id];
    },
    userColor(id) {
      return Constants.COLORS[_.keys(this.asta_squadre).indexOf(id)];
    },
  },
  computed: {
    ...Vuex.mapGetters([
      "asta_squadre",
      "user_uid",
      "asta_messages",
      "is_mobile",
    ]),
  },
  destroyed() {
    // db.off("newMessage", this.onNewMessage);
    //db.removeListener('fetchedSquadre', this.setupEmojioneArea);
    console.log("<-- AstaChat destroyed.");
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.chat {
  display: flex;
  flex-direction: column;
  justify-content: end;
  height: 100%;
  // padding-bottom: 45px;
  // background-image: url(/static/img/bg-seamless.png);
  // background: linear-gradient(transparent, rgba(245, 245, 245, 0.7));
}

.chat-panel {
  overflow-y: auto;
}

ul.chat-messages {
  width: 100%;
  height: 100%;
  list-style: none;
  padding-left: 12px;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(black),
    to(rgba(0, 0, 0, 0))
  );
}

ul.chat-messages li.my-chat {
  float: right;
  border-radius: 8px 0 8px 8px;
  margin-right: 10px;
  // background: #607d8b;
  background-color: var(--v-navy-darken2);
  color: white;
}

ul.chat-messages li {
  list-style: none;
  clear: both;
  float: left;
  // background: white;
  background-color: var(--v-navy-darken2);
  color: white;
  padding: 4px 20px 2px 10px;
  border-radius: 0px 8px 8px 8px;
  // box-shadow: 0 3px 6px 0px rgb(0 0 0 / 10%);
  margin-top: 3px;
  margin-bottom: 3px;
  margin-right: 10px;
  text-align: left;
}

.chat-user {
  font-weight: bold;
}

.my-chat .chat-user {
  display: none;
}

img.emojione {
  width: 24px;
  height: 24px;
}

.emojionearea {
  margin-top: 8px;
  text-align: left;
}
</style>
